export const useFbe = () => {
  const fbeSend = eventName => window.fbq && window.fbq('track', eventName)
  return { fbeSend }
}
